import {
  DimensionType,
  FieldMetadata,
  RecurrentPriceModeType,
} from './../reducer'
import { AnyAction } from 'redux'
import {
  startLoading,
  stopLoading,
} from '../../../../common/modules/loading/actions'
import { LoadingTypes } from '../../../../common/modules/loading/reducer'
import { updateAppAlert } from '../../../../common/modules/appAlert/actions'
import { getErrorMessages } from '../../../../common/utils/error'
import {
  privateOfferCreationSuccess,
  privateOfferSaveSuccess,
  RequestFailureMessage,
} from '../../../../common/utils/messagesContants'
import { AxiosError, AxiosResponse } from 'axios'
import emptyPrivateOffer from '../../../../mocks/emptyPrivateOffers.json'
import emptyAzurePrivateOffer from '../../../../mocks/emptyAzurePrivateOffer.json'
import emptyGcpPrivateOffer from '../../../../mocks/emptyGcpPrivateOffer.json'
import { camelize, snakeize } from 'casing'
import { AppDispatch, RootState } from '../../../../store'
import { PlanType } from '@labrav/react-components'
import {
  CloudMarketplace,
  CommonDimensionField,
  ContainerPricingModel,
  Product,
  ProductDimension,
  ProductPlan,
} from '../../productsListing/reducer'
import {
  OffersWithErrors,
  getErrorObjectForAField,
  createErrorObjectForPlan,
  PrivateOfferCreationActionTypes,
} from './reducer'
import {
  AzureOfferPlan,
  AzurePOPricing,
  AzurePriceInputOption,
  AzurePricingType,
  Dimension,
  EntitlementOption,
  EulaType,
  GCPOfferPlan,
  GCPOfferPlanDimesnion,
  GcpPostPaymentTypes,
  Installments,
  OfferStatus,
  MetaData,
  OfferRecipients,
  PaymentType,
  PlanTypeGCP,
  PriceTypes,
  PrivateOffer,
  OfferStakeholders,
  ScheduleType,
} from '../reducer'
import { cloneDeep, get, isEmpty, isNil, lowerCase, upperCase } from 'lodash'
import {
  getSinglePrivateOffer,
  patchPrivateOffersData,
  postPrivateOffer,
} from '../../../api/markeplace'
import { defaultCrmType } from '../../../../common/utils/constants'
import {
  ResellerInfo,
  Stakeholders,
} from '../../../../admin/modules/resaleAuthorizations/reducer'
import {
  getAzureSinglePrivateOffer,
  patchAzurePrivateOffersData,
  postAzurePrivateOffer,
} from '../../../api/azure'
import { DateTime } from 'luxon'
import { isNonEmptyNumber } from '../../../../common/utils/validateMinMax'
import { getDiscountedPriceValue } from '../../../../common/utils/getDiscountedPriceValue'
import {
  getGcpSinglePrivateOffer,
  putGCPPrivateOffersData,
} from '../../../api/gcp'
import { isOneHourContractDuration } from '../../../utils/containerOfferHelperFunctions'
import { PartnerType } from '../../../../common/modules/partner/action'
import { errorLogger } from '../../../../common/utils/errorLogger'
import {
  getMarketplaceDefaultOfferMarketplaceMapping,
  getMarketplaceDefaultOffersReferralMapping,
} from '../../../../common/api/mappingManager'
import { getAzureMappedPlans } from '../../resaleAuthorization/actions'
import { UserState } from '../../../../oppsync/modules/userList/reducer'
import {
  calculateUsageEndDateFromDuration,
  calculateUsageDurationFromDates,
  getUsageDuration,
  getPricingModel,
  parseDurationFromServiceLength,
} from '../../../utils/amiPrivateOfferUtil'
import { initialPricesObject, KeyValue } from './types'
import {
  MarketplaceFieldMapping,
  MarketplaceFieldMappingInstallments,
  MarketplaceFieldMappingMetadata,
  MarketplaceTemplateData,
  MarketplaceTemplatesDataFieldMappings,
} from '../../marketplaceMappingManager/reducer'
import { emitSalesforceResourceSaved } from '../../../../common/utils/salesforceResourceBroker'

const validateFields = [
  'installments',
  'offerExpirationDate',
  'dimensions',
  'offerRecipients',
  'companyName',
  'awsAccountId',
  'emailCustomMessage',
  'privateOfferName',
  'serviceLength',
  'metaData',
  'subscriptionEndDate',
  'billingAccountId',
  'offerStartDate',
  'variableStartDate',
  'acceptBy',
  'plans',
  'preparedBy',
  'agreementStartDate',
]

export const arrayFieldsForValidations = [
  'installments',
  'dimensions',
  'offerRecipients',
  'metaData',
]
//private offer actions

export const getUpdatedDimensionsForEmptyPOAndResaleSubscription = (
  productDimensions: ProductDimension[],
  isResale?: boolean,
  resetPrices = false
) => {
  return productDimensions.map(dimension => {
    const {
      id,
      createdAt,
      price,
      prices,
      freeTrial,
      valueDataType,
      ...remainingData
    } = dimension
    const updatedDimension: ProductDimension = {
      ...remainingData,
      dimensionId: id,
      type: remainingData.isAdditionalUsageAllowed
        ? 'additional_usage'
        : 'standard',
    }
    if (isResale) {
      updatedDimension.prices = prices
    } else if (resetPrices) {
      return {
        ...updatedDimension,
        prices: {
          ...(prices as PriceTypes),
          subscriptionPrice: null,
        },
      }
    } else {
      updatedDimension.price = (prices as PriceTypes)
        ?.subscriptionPrice as unknown as PriceTypes
    }
    return updatedDimension
  })
}
export const getUpdatedDimensionsForEmptyPOAndResaleContract = (
  productDimensions: ProductDimension[],
  isResale = false,
  resetPrices = false
) => {
  const additionalUsageDimensions =
    productDimensions.filter(dimension => dimension.isAdditionalUsageAllowed) ||
    []
  return additionalUsageDimensions.map(dimension => {
    const {
      id,
      createdAt,
      price,
      prices,
      freeTrial,
      valueDataType,
      additionalUsageDescription,
      isAdditionalUsageAllowed,
      labelDescription,
      ...remainingData
    } = dimension
    const updatedDimension = {
      ...remainingData,
      isAdditionalUsageAllowed,
      price: (prices as PriceTypes)?.additionalUsagePrice ?? null,
      dimensionId: id,
      labelDescription: isAdditionalUsageAllowed
        ? additionalUsageDescription || labelDescription
        : labelDescription,
      type: 'additional_usage',
    }
    if (isResale) {
      return {
        ...updatedDimension,
        prices,
      }
    } else if (resetPrices) {
      return {
        ...updatedDimension,
        prices: {
          ...(prices as PriceTypes),
          additionalUsagePrice: null,
        },
      }
    } else {
      return updatedDimension
    }
  })
}
const getAdditionalUsageDimensionsForContainer = (
  productDimensions: ProductDimension[]
) => {
  return productDimensions.map(dimension => {
    const {
      id,
      createdAt,
      price,
      prices,
      freeTrial,
      valueDataType,
      ...remainingData
    } = dimension

    const updatedDimension = {
      ...remainingData,
      price: (prices as PriceTypes)?.additionalUsagePrice ?? null,
      dimensionId: id,
      type: 'additional_usage',
      isAdditionalUsageAllowed: true,
    }

    return updatedDimension
  })
}
const amiDimensions = (product: Product) => {
  return product?.productDimensions?.map(
    ({ prices, ...remainingDimension }) => ({
      ...remainingDimension,
      dimensionId: remainingDimension?.id,
      additionalUsagePrice: (prices as PriceTypes)?.additionalUsagePrice,
    })
  )
}
const containerDimensions = (product: Product) => {
  const additionalDimensions = getAdditionalUsageDimensionsForContainer(
    product.productDimensions as ProductDimension[]
  )
  if (
    product.containerPricingModel === ContainerPricingModel.HOURLY ||
    product.containerPricingModel === ContainerPricingModel.USAGE
  ) {
    const dimensionsWithType = product?.productDimensions?.map(dimension => ({
      ...dimension,
      type: 'standard',
      dimensionId: dimension?.id,
    }))

    const updatedDimensions = [
      ...(dimensionsWithType || []),
      ...additionalDimensions,
    ]
    return updatedDimensions
  } else {
    const updatedDimensions = [
      {
        label: '',
        labelDescription: '',
        type: 'standard',
        isAdditionalUsageAllowed: false,
        currency: 'USD',
      },
    ]
    return updatedDimensions
  }
}

export const getDimensionsBasedOnProductType = (
  product: Product,
  labraNewUiRevamp: boolean
) => {
  if (product.productType === PlanType.CONTAINER && labraNewUiRevamp === true) {
    return containerDimensions(product)
  } else if (product.productType === PlanType.AMI) {
    if (product.containerPricingModel !== ContainerPricingModel.CONTRACT) {
      return amiDimensions(product)
    } else {
      return [
        {
          label: '',
          labelDescription: '',
          type: 'standard',
          isAdditionalUsageAllowed: false,
          currency: 'USD',
        },
      ]
    }
  } else {
    return getUpdatedDimensions(
      product?.productDimensions || [],
      product?.productType
    ) as Dimension[]
  }
}

export const getUpdatedDimensionsForDraftPO = (
  dimensions: Dimension[],
  productId: string
) => {
  return dimensions.map((dimension: Dimension) => {
    const { id, createdAt, ...remainingDimension } = dimension
    remainingDimension.awsProductId = productId
    return remainingDimension
  })
}
export const getUpdatedDimensions = (
  dimensions: ProductDimension[],
  planType?: PlanType,
  isResale?: boolean
) => {
  if (planType === PlanType.SAAS_SUBSCRIPTION) {
    return getUpdatedDimensionsForEmptyPOAndResaleSubscription(
      dimensions,
      isResale
    )
  } else {
    return getUpdatedDimensionsForEmptyPOAndResaleContract(dimensions, isResale)
  }
}

const getEntitlementOption = (
  labraNewUiRevamp: boolean | undefined,
  product: Product
): EntitlementOption => {
  switch (product.productType) {
    case PlanType.CONTAINER:
      if (labraNewUiRevamp) {
        return product.containerPricingModel === ContainerPricingModel.CONTRACT
          ? EntitlementOption.SINGLE
          : EntitlementOption.MANY
      }
      return EntitlementOption.SINGLE
    case PlanType.AMI:
      return EntitlementOption.MANY
    default:
      return EntitlementOption.SINGLE
  }
}

const getInitialPrivateOfferDataBasedOnCloud = (
  cloud: CloudMarketplace,
  product: Product,
  getState: () => RootState,
  crmOpportunityId?: string,
  labraNewUiRevamp?: boolean,
  partnerType: PartnerType = PartnerType.User
) => {
  const crm_opportunity_id = crmOpportunityId ?? null
  const email_custom_message = product?.emailCustomMessage || null
  const { email, firstName, lastName, givenName, familyName } =
    getState().userProfile.userProfile
  const { offerRecipients } =
    getState().privateOffersInCreation.currentPrivateOfferInCreation[
      product?.productId
    ] || []
  const hasCreatorData = !isEmpty(firstName) && !isEmpty(email)
  const creatorData = hasCreatorData
    ? {
        creator_data: { creator_name: firstName, creator_email: email },
      }
    : {}
  switch (cloud) {
    case 'AWS': {
      const planType = product?.productType

      const initialOfferRecipients = labraNewUiRevamp
        ? (offerRecipients && offerRecipients.length) > 0
          ? offerRecipients
          : [{ email: '', title: '', firstName: '', lastName: '' }]
        : []

      return {
        ...emptyPrivateOffer,
        crm_opportunity_id,
        email_custom_message,
        ...creatorData,
        entitlement_option: getEntitlementOption(labraNewUiRevamp, product),
        eula_type:
          labraNewUiRevamp && product.productType === PlanType.CONTAINER
            ? 'PUBLIC'
            : planType === PlanType.PROFESSIONAL_SERVICES
              ? 'CUSTOM'
              : 'STANDARD',
        awsProductId: product?.productId,
        ...(planType === PlanType.SAAS_CONTRACT
          ? { variable_start_date: true, agreement_start_date: null }
          : {}),
        dimensions: getDimensionsBasedOnProductType(
          product,
          labraNewUiRevamp ? true : false
        ),
        offer_recipients: initialOfferRecipients,
        ...(labraNewUiRevamp && product.productType === PlanType.CONTAINER
          ? {
              container_offer_serviceLength:
                product?.containerPricingModel !==
                ContainerPricingModel.CONTRACT
                  ? '1Y'
                  : '12M',
            }
          : {}),
        ...(labraNewUiRevamp &&
        (product.productType === PlanType.CONTAINER ||
          product.productType === PlanType.AMI)
          ? {
              installments: [
                { paymentDate: '', amount: null, currency: 'USD' },
              ],
              usageDuration: null,
            }
          : {}),
        ...((labraNewUiRevamp &&
          (product.productType === PlanType.CONTAINER ||
            product.productType === PlanType.SAAS_CONTRACT)) ||
        product.productType === PlanType.SAAS_SUBSCRIPTION
          ? { meta_data: [{ key: '', value: '' }] }
          : {}),
        ...(labraNewUiRevamp &&
        (product.productType === PlanType.CONTAINER ||
          product.productType === PlanType.SAAS_CONTRACT ||
          product.productType === PlanType.SAAS_SUBSCRIPTION ||
          product.productType === PlanType.AMI)
          ? {
              offerStakeholders: crmOpportunityId
                ? []
                : creatorData.creator_data?.creator_email
                  ? [
                      {
                        email: creatorData.creator_data?.creator_email,
                        name: creatorData.creator_data?.creator_name,
                      },
                    ]
                  : [],
              customOfferStakeholders: [],
            }
          : {}),
        ...(labraNewUiRevamp &&
        (product.productType === PlanType.CONTAINER ||
          product.productType === PlanType.SAAS_CONTRACT ||
          product.productType === PlanType.AMI)
          ? {
              tcv: null,
              flexiblePaymentType: ScheduleType.CUSTOM,
              firstInstallmentDate: new Date().toISOString().split('T')[0],
            }
          : {}),
        ...(product.productType === PlanType.AMI
          ? {
              durationType: 'DAYS',
              durationLength: '',
              usageEndDate: null,
              serviceLength: undefined,
              pricingModel: 'upfront-payment',
            }
          : {}),
        metaData: [{ key: '', value: '' }],
      }
    }
    case 'AZURE': {
      return {
        ...camelize(emptyAzurePrivateOffer),
        crmOpportunityId: crm_opportunity_id,
        emailCustomMessage: email_custom_message,
        offerRecipients:
          (offerRecipients && offerRecipients.length) > 0
            ? offerRecipients
            : [{ email: '', title: '', firstName: '', lastName: '' }],
        preparedBy: email || '',
        offerStakeholders: email
          ? [
              {
                firstName: firstName || givenName || '',
                lastName: lastName || familyName || '',
                email: email || '',
              },
            ]
          : [],
      }
    }
    case 'GCP': {
      return {
        ...emptyGcpPrivateOffer,
        crm_opportunity_id,
        email_custom_message,
        individual_discount: false,
        offerStakeholders: crmOpportunityId
          ? []
          : [
              {
                firstName: firstName || givenName,
                lastName: lastName || familyName,
                email: email,
              },
            ],
      }
    }
  }
}

const getContainerServiceLengthValueFromOffer = (
  offerResponse: PrivateOffer,
  product?: Product
) => {
  const containerOfferServiceLength =
    (offerResponse.containerOfferServiceLength || '') as string

  return containerOfferServiceLength.replace(/[DM]/, '')
}

const mapOfferAWSOffer = (
  offerResonse: PrivateOffer,
  getState: () => RootState,
  product?: Product,
  partnerType: PartnerType = PartnerType.User
) => {
  const {
    offerStakeholders,
    offerRecipients,
    metaData,
    installments,
    flexiblePaymentType,
    flexiblePaymentTerms,
    containerOfferServiceLength,
    auditJson,
  } = offerResonse
  const users = getState().userList[partnerType].userList.users.map(
    ({ email }) => email
  )
  const stackHolderExisting =
    (offerStakeholders || [])?.filter(item => users.includes(item.email)) || []
  const stackHolderCustom =
    (offerStakeholders || [])?.filter(item => !users.includes(item.email)) || []

  const installmentsInfo =
    (installments || []).length > 0
      ? installments
      : [{ paymentDate: '', amount: null, currency: 'USD' }]

  const totalContractValue =
    installments && installments.length > 0
      ? installments.reduce((total, installment) => {
          return total + (installment?.amount || 0)
        }, 0) || null
      : null

  const firstInstallmentDate =
    installments && installments.length > 0
      ? installments[0]?.paymentDate || null
      : null

  return {
    offerStakeholders: [...stackHolderExisting],
    customOfferStakeholders: [...stackHolderCustom],
    auditJson,
    offerRecipients:
      (offerRecipients || []).length > 0
        ? offerRecipients
        : [{ email: '', title: '', firstName: '', lastName: '' }],
    metaData: (metaData || []).length > 0 ? metaData : [{ key: '', value: '' }],
    ...(product?.productType === PlanType.CONTAINER ||
    product?.productType === PlanType.SAAS_CONTRACT ||
    product?.productType === PlanType.AMI
      ? {
          installments: installmentsInfo,
          flexiblePaymentType:
            flexiblePaymentType ||
            (product?.productType === PlanType.AMI
              ? ScheduleType.MONTHLY
              : ScheduleType.CUSTOM),
          tcv: totalContractValue,
          firstInstallmentDate: firstInstallmentDate,
          ...(product?.productType === PlanType.AMI
            ? {
                pricingModel: getPricingModel(
                  flexiblePaymentTerms,
                  containerOfferServiceLength
                ),
              }
            : {}),
        }
      : {}),
    ...(product?.productType === PlanType.CONTAINER
      ? {
          ...getContainerOfferDimensions(offerResonse, product),
          containerOfferServiceLength: getContainerServiceLengthValueFromOffer(
            offerResonse,
            product
          ),
        }
      : {}),
  }
}

const getContainerOfferDimensions = (
  offerResonse: PrivateOffer,
  product?: Product
) => {
  if (!product?.productId) {
    return {}
  }
  const standardDimensionEmpty =
    (offerResonse?.dimensions || []).filter(
      dimensionItem => dimensionItem.type === 'standard'
    ).length === 0

  const dimensionsWithType = (product?.productDimensions || [])?.map(
    dimension => ({
      ...dimension,
      type: 'standard',
      dimensionId: dimension?.id,
    })
  )

  if (isOneHourContractDuration(offerResonse?.containerOfferServiceLength)) {
    return {
      dimensions: getUpdatedDimensionsForDraftPO(
        (offerResonse?.dimensions || [])?.concat(
          dimensionsWithType as unknown as Dimension[]
        ),
        product?.productId
      ),
    }
  } else if (
    (product?.containerPricingModel === ContainerPricingModel.CONTRACT ||
      (product?.containerPricingModel === ContainerPricingModel.USAGE &&
        offerResonse?.flexiblePaymentTerms)) &&
    standardDimensionEmpty
  ) {
    return {
      dimensions: getUpdatedDimensionsForDraftPO(
        (offerResonse?.dimensions || [])?.concat([
          {
            label: '',
            labelDescription: '',
            type: 'standard',
            isAdditionalUsageAllowed: false,
            currency: 'USD',
          },
        ]),
        product?.productId
      ),
    }
  } else {
    return {}
  }
}

export const getPrivateOfferDataFromAPIResponse = async (
  cloud: CloudMarketplace,
  {
    partnerId,
    privateOfferId,
    crmOpportunityId,
    productId,
    product,
    userList,
  }: {
    productId: string
    partnerId: string
    privateOfferId: string
    crmOpportunityId?: string
    product?: Product
    userList?: UserState[]
  },
  dispatch: AppDispatch,
  getState?: () => RootState
) => {
  try {
    switch (cloud) {
      case 'AWS': {
        const { data } = await getSinglePrivateOffer(
          partnerId,
          privateOfferId,
          crmOpportunityId
        )
        const { productName, links, ...remainingData } = camelize(data || {})

        const offerExpirationDate = convertDateFromAPIResponse(
          (remainingData as PrivateOffer)?.offerExpirationDate
        )
        const usageDuration = (remainingData as PrivateOffer)?.usageDuration
        const calculatedUsageEndDate = calculateUsageEndDateFromDuration(
          offerExpirationDate,
          usageDuration
        )
        const containerOfferServiceLength = (remainingData as PrivateOffer)
          ?.containerOfferServiceLength
        const { durationType, durationLength } = parseDurationFromServiceLength(
          containerOfferServiceLength
        )

        return {
          ...remainingData,
          awsProductId: productId,
          ...(product?.productType === PlanType.AMI
            ? {
                offerExpirationDate,
                ...(calculatedUsageEndDate
                  ? { usageEndDate: calculatedUsageEndDate }
                  : {}),
                ...(durationType ? { durationType } : {}),
                ...(durationLength !== null ? { durationLength } : {}),
              }
            : {
                offerExpirationDate: convertDateFromAPIResponse(
                  (remainingData as PrivateOffer)?.offerExpirationDate
                ),
              }),
          ...(product?.productType === PlanType.SAAS_SUBSCRIPTION
            ? {
                subscriptionEndDate: convertDateFromAPIResponse(
                  (remainingData as PrivateOffer)?.subscriptionEndDate as string
                ),
              }
            : {}),
          ...(product?.productType === PlanType.SAAS_CONTRACT
            ? {
                agreementStartDate: convertDateFromAPIResponse(
                  (remainingData as PrivateOffer)?.agreementStartDate
                ),
              }
            : {}),
          ...(product?.productType === PlanType.SAAS_CONTRACT &&
          remainingData.variableStartDate === false
            ? {
                agreementStartDate: convertDateFromAPIResponse(
                  (remainingData as PrivateOffer)?.agreementStartDate
                ),
              }
            : {}),
          dimensions: getUpdatedDimensionsForDraftPO(
            remainingData.dimensions || [],
            productId
          ),
          ...((product?.productType === PlanType.CONTAINER ||
            product?.productType === PlanType.SAAS_CONTRACT ||
            product?.productType === PlanType.SAAS_SUBSCRIPTION ||
            product?.productType === PlanType.AMI) &&
          getState
            ? {
                ...mapOfferAWSOffer(
                  remainingData as PrivateOffer,
                  getState,
                  product
                ),
              }
            : {}),
        }
      }
      case 'AZURE': {
        const { data } = await getAzureSinglePrivateOffer(
          partnerId,
          privateOfferId,
          crmOpportunityId,
          productId
        )
        const { plans, ...offerData } = data
        const { links, id, eulaFiles, offerStakeholders, ...remainingData } =
          camelize(offerData || {})
        const users = (userList || []).map(({ email }) => email)
        const existingStakeHolder =
          (offerStakeholders || [])?.filter((item: Stakeholders) =>
            users.includes(item.email)
          ) || []
        const stackHolderCustom =
          (offerStakeholders || [])?.filter(
            (item: Stakeholders) => !users.includes(item.email)
          ) || []
        const payloadPlans = plans?.length
          ? getAzureMappedPlans({ plans, product: product as Product })
          : [
              {
                displayName: '',
                planId: '',
                offerPricingType: 'saasNewCustomizedPlans',
                description: '',
                labraPlanId: '',
                discountPercentage: null,
                pricing: {
                  recurrentPrice: {
                    recurrentPriceMode: '',
                    priceInputOption: 'usd',
                    prices: [],
                  },
                },
              },
            ]

        const offerExpirationDate = convertDateFromAPIResponse(
          (remainingData as PrivateOffer)?.offerExpirationDate
        )
        const usageDuration = (remainingData as PrivateOffer)?.usageDuration
        const calculatedUsageEndDate = calculateUsageEndDateFromDuration(
          offerExpirationDate,
          usageDuration
        )
        const containerOfferServiceLength = (remainingData as PrivateOffer)
          ?.containerOfferServiceLength
        const { durationType, durationLength } = parseDurationFromServiceLength(
          containerOfferServiceLength
        )

        return {
          ...remainingData,
          draft: true,
          eulaFiles: eulaFiles || [],
          privateOfferId: privateOfferId,
          azurePricingType:
            (plans || []).length > 0 ? plans[0].discount_type : '',
          plans: payloadPlans,
          eulaType:
            (remainingData as PrivateOffer)?.eulaType || EulaType.STANDARD,
          ...(product?.productType === PlanType.AMI
            ? {
                offerExpirationDate,
                ...(calculatedUsageEndDate
                  ? { usageEndDate: calculatedUsageEndDate }
                  : {}),
                ...(durationType ? { durationType } : {}),
                ...(durationLength !== null ? { durationLength } : {}),
              }
            : {
                offerExpirationDate: convertDateFromAPIResponse(
                  (remainingData as PrivateOffer)?.offerExpirationDate
                ),
              }),

          acceptBy: convertDateFromAPIResponse(
            (remainingData as PrivateOffer)?.acceptBy
          ),
          offerStartDate: convertDateFromAPIResponse(
            (remainingData as PrivateOffer)?.offerStartDate
          ),
          existingContractRenewal: (remainingData as PrivateOffer)
            ?.existingContractRenewal,
          offerStakeholders: [...existingStakeHolder],
          customOfferStakeholders: [...stackHolderCustom],
          offerRecipients:
            (remainingData as PrivateOffer)?.offerRecipients &&
            (remainingData as PrivateOffer)?.offerRecipients.length > 0
              ? (remainingData as PrivateOffer).offerRecipients
              : [{ email: '', title: '', firstName: '', lastName: '' }],
          metaData:
            (remainingData as PrivateOffer)?.metaData &&
            (remainingData as PrivateOffer)?.metaData.length > 0
              ? (remainingData as PrivateOffer).metaData
              : [{ key: '', value: '' }],
        }
      }
      case 'GCP': {
        const { data } = await getGcpSinglePrivateOffer(
          partnerId,
          privateOfferId,
          crmOpportunityId,
          productId
        )
        const {
          links,
          eulaFiles,
          labraOfferId,
          contractDuration,
          paymentFrequency,
          labraPlanId,
          offerMetadata,
          plan: notUsedPlan,
          tcv,
          installmentSchedule,
          individualDiscount,
          ...remainingData
        } = camelize(data)

        const offerPlan = getConvertedGCPPlanDataForOffer(data, product)

        const offerExpirationDate = convertDateFromAPIResponse(
          (remainingData as PrivateOffer)?.offerExpirationDate
        )
        const usageDuration = (remainingData as PrivateOffer)?.usageDuration
        const calculatedUsageEndDate = calculateUsageEndDateFromDuration(
          offerExpirationDate,
          usageDuration
        )
        const containerOfferServiceLength = (remainingData as PrivateOffer)
          ?.containerOfferServiceLength
        const { durationType, durationLength } = parseDurationFromServiceLength(
          containerOfferServiceLength
        )

        return {
          ...remainingData,
          eulaFile: eulaFiles || [],
          ...(product?.productType === PlanType.AMI
            ? {
                offerExpirationDate,
                ...(calculatedUsageEndDate
                  ? { usageEndDate: calculatedUsageEndDate }
                  : {}),
                ...(durationType ? { durationType } : {}),
                ...(durationLength !== null ? { durationLength } : {}),
              }
            : {
                offerExpirationDate: convertDateFromAPIResponse(
                  (remainingData as PrivateOffer)?.offerExpirationDate
                ),
              }),
          privateOfferId: labraOfferId,
          notes: offerMetadata?.notes,
          emailCustomMessage: offerMetadata?.emailCustomMessage,
          ...offerPlan,
        }
      }
    }
  } catch (err: any) {
    dispatch(
      updateAppAlert({
        message: getErrorMessages([RequestFailureMessage])(
          err.response as AxiosResponse<ErrorResponse>
        ),
        messageType: 'ERROR',
        autoClose: true,
      })
    )
  }
}

export const getConvertedGCPPlanDataForOffer = (
  apiOfferResponseData: any,
  product?: Product
) => {
  const {
    labraPlanId,
    paymentFrequency,
    individualDiscount,
    installmentSchedule,
    tcv,
    contractDuration,
  } = camelize(apiOfferResponseData)
  const { plan } = apiOfferResponseData
  let offerPlan = {}
  if (plan) {
    const {
      metric_pricing,
      installment_info,
      payment_frequency,
      ...remainingPlan
    } = plan
    const otherPlanInfo = camelize(remainingPlan)
    const productPlan = product?.plans?.find(
      planItem => planItem.planId === labraPlanId
    )
    const planType = productPlan?.planType

    const planMeters =
      planType === PlanTypeGCP.USAGE ||
      (planType === PlanTypeGCP.FLAT_FEE_USAGE &&
        GcpPostPaymentTypes.includes(paymentFrequency))
        ? convertGCPPlanMeterObjectToArray(plan?.metric_pricing, productPlan)
        : undefined

    const planInstallments =
      paymentFrequency === PaymentType.CUSTOM
        ? {
            installmentInfo: plan?.installment_info.map(
              (installmentInfoItem: any) => ({
                flatFeePrice: installmentInfoItem?.flat_fee_price,
                installmentDate: convertDateFromAPIResponse(
                  installmentInfoItem?.installment_date as string
                ),
                metricPricing:
                  planType === PlanTypeGCP.FLAT_FEE_USAGE
                    ? convertGCPPlanMeterObjectToArray(
                        installmentInfoItem?.metric_pricing,
                        productPlan
                      )
                    : undefined,
              })
            ),
          }
        : {}

    const discountValue = !individualDiscount
      ? {
          ...((planType === PlanTypeGCP.USAGE ||
            (planType === PlanTypeGCP.FLAT_FEE_USAGE &&
              GcpPostPaymentTypes.includes(paymentFrequency))) &&
          planMeters
            ? { discount: get(planMeters, '[0].discount', undefined) }
            : {}),
          ...(planType === PlanTypeGCP.FLAT_FEE_USAGE &&
          paymentFrequency === PaymentType.CUSTOM &&
          planInstallments.installmentInfo
            ? {
                discount: get(
                  planInstallments.installmentInfo[0],
                  'metricPricing[0].discount',
                  undefined
                ),
              }
            : {}),
        }
      : {}
    offerPlan = {
      plan: {
        ...otherPlanInfo,
        planId: labraPlanId,
        description: productPlan?.description,
        paymentType: paymentFrequency,
        planType,
        tcv,
        installmentSchedule: lowerCase(installmentSchedule),
        individualDiscount: individualDiscount,
        serviceLength: contractDuration,
        ...discountValue,
        ...planInstallments,
        ...(planMeters
          ? {
              metricPricing: planMeters,
            }
          : {}),
      },
    }
  }
  return offerPlan
}

export const convertGCPPlanMeterObjectToArray = (
  planMeters: any,
  productPlan?: ProductPlan
) => {
  const meters: GCPOfferPlanDimesnion[] = []
  if (productPlan) {
    if (planMeters) {
      const productPlanMeters = productPlan?.dimensions
      Object.keys(planMeters).forEach(planMeterItem => {
        const productPlanDimension = (
          productPlanMeters as CommonDimensionField[]
        ).find(dimensionItem => dimensionItem.id === planMeterItem)

        meters.push({
          id: planMeterItem,
          price: planMeters[planMeterItem].price,
          discount: planMeters[planMeterItem].discount,
          currency: productPlanDimension?.currency || 'USD',
          label: productPlanDimension?.label || '',
          name: productPlanDimension?.name || '',
        })
      })
    } else {
      return getDimensionFromProduct(productPlan)
    }
  }
  return meters
}

export const convertDateFromAPIResponse = (date?: string) => {
  return date
    ? DateTime.fromISO(date).toFormat('yyyy-MM-dd').toLocaleString()
    : null
}

// const calculateUsageEndDateFromDuration = (
//   offerExpirationDate: string | null | undefined,
//   usageDuration: number | string | null | undefined
// ): string | null => {
//   if (!offerExpirationDate || !usageDuration) {
//     return null
//   }

//   try {
//     const expirationDate = DateTime.fromISO(offerExpirationDate)
//     if (!expirationDate.isValid) {
//       return null
//     }

//     const durationDays =
//       typeof usageDuration === 'string'
//         ? parseInt(usageDuration, 10)
//         : usageDuration

//     if (isNaN(durationDays) || durationDays <= 0) {
//       return null
//     }

//     const endDate = expirationDate.plus({ days: durationDays })
//     return endDate.toFormat('yyyy-MM-dd').toLocaleString()
//   } catch (error) {
//     return null
//   }
// }

// const parseDurationFromServiceLength = (
//   containerOfferServiceLength: string | null | undefined
// ): { durationType: DurationType | null; durationLength: number | null } => {
//   if (!containerOfferServiceLength) {
//     return { durationType: null, durationLength: null }
//   }

//   try {
//     const serviceLength = containerOfferServiceLength.toString()
//     // Parse string format like "12M", "1Y", "30D", "4W"
//     const match = serviceLength.match(/^(\d+(?:\.\d+)?)([MYWDH])?$/i)

//     if (!match) {
//       return { durationType: null, durationLength: null }
//     }

//     const value = parseFloat(match[1])
//     const unit = match[2]?.toUpperCase()

//     if (isNaN(value) || value <= 0) {
//       return { durationType: null, durationLength: null }
//     }

//     let durationType: DurationType | null = null

//     switch (unit) {
//       case 'Y':
//         durationType = DurationType.YEARS
//         break
//       case 'M':
//         durationType = DurationType.MONTHS
//         break
//       case 'W':
//         durationType = DurationType.WEEKS
//         break
//       case 'D':
//         durationType = DurationType.DAYS
//         break
//       case 'H':
//         // Hours are not supported in DurationType, return null
//         return { durationType: null, durationLength: null }
//       default:
//         // If no unit, assume months
//         durationType = DurationType.MONTHS
//     }

//     return {
//       durationType,
//       durationLength: Math.round(value * 100) / 100, // Round to 2 decimal places
//     }
//   } catch (error) {
//     return { durationType: null, durationLength: null }
//   }
// }

export const getArrayFieldsForValidation = (cloud: CloudMarketplace) => {
  switch (cloud) {
    case 'AWS': {
      return arrayFieldsForValidations
    }
    case 'AZURE': {
      return ['offerRecipients', 'metaData', 'plans']
    }
    case 'GCP': {
      return []
    }
    case 'REDHAT': {
      return []
    }
  }
}
export const getCurrentPrivateOfferInCreation =
  ({
    productId,
    partnerId,
    privateOfferId,
    crmOpportunityId,
    labraNewUiRevamp = false,
  }: {
    productId: string
    partnerId: string
    privateOfferId: string
    crmOpportunityId?: string
    labraNewUiRevamp?: boolean
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(clearPrivateOfferInCreation(productId))
    const cloudMarketplace = getState().productListingFilters.cloudMarketplace

    const product =
      getState().productsListing[cloudMarketplace].products.rows.find(
        product => product.productId === productId
      ) || ({} as Product)
    let offerData = {}

    if (isEmpty(privateOfferId)) {
      offerData = {
        ...getInitialPrivateOfferDataBasedOnCloud(
          cloudMarketplace,
          product,
          getState,
          crmOpportunityId,
          labraNewUiRevamp
        ),
      }
    } else {
      const { userList } = getState().userList.user
      offerData = await getPrivateOfferDataFromAPIResponse(
        cloudMarketplace,
        {
          productId,
          partnerId,
          privateOfferId,
          crmOpportunityId,
          product,
          userList: userList.users,
        },
        dispatch,
        getState
      )
    }
    let plans = [] as Record<string, unknown>[]
    if (cloudMarketplace === 'AZURE') {
      plans = get(offerData, 'plans', []) || []
    }
    const finalData = camelize({
      ...offerData,
    })
    const errors =
      cloudMarketplace === 'GCP' || cloudMarketplace === 'AZURE'
        ? {}
        : createOfferErrors(
            finalData,
            getArrayFieldsForValidation(cloudMarketplace)
          )
    await dispatch(
      setPrivateOfferInCreation({
        productId,
        data: {
          ...finalData,
          ...(cloudMarketplace === 'AZURE' ? { plans } : {}),
        },
        errors,
        noOfTimesSaved: isEmpty(privateOfferId) ? 0 : 2,
      })
    )
  }
export type setPrivateOfferInCreationProps = {
  productId: string
  data: Record<string, unknown>
  errors: Record<string, unknown>
  noOfTimesSaved: number
}
export const setPrivateOfferInCreation = ({
  productId,
  data,
  errors,
  noOfTimesSaved = 0,
}: setPrivateOfferInCreationProps) =>
  ({
    type: PrivateOfferCreationActionTypes.SET_CREATE_PRIVATE_OFFERS_DATA,
    payload: { productId, privateOfferData: data, errors, noOfTimesSaved },
  }) as unknown as AnyAction

export const updatePrivateOfferInCreation =
  (data: KeyValue, productId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const cloudType = getState().productListingFilters.cloudMarketplace
    await dispatch(setPrivateOffersData(data, productId))
    if (validateFields.includes(data.key)) {
      await dispatch(
        setErrorsOnPrivateOfferCreation(
          data.key as string,
          productId,
          cloudType
        )
      )
    }
  }
export const updateStandardDimensionsOnPrivateOffer = (
  index: number,
  productId: string,
  dimension: Dimension
) => ({
  type: PrivateOfferCreationActionTypes.UPDATE_STANDARD_DIMENSIONS_ON_PRIVATE_OFFER,
  payload: { index, productId, dimension },
})
export const setPrivateOffersData = (data: KeyValue, productId: string) => ({
  type: PrivateOfferCreationActionTypes.UPDATE_PRIVATE_OFFERS,
  payload: { privateOfferData: data, productId },
})
export const addRowsOnPrivateOffer = (
  key: string,
  productId: string,
  type = 'standard'
) => ({
  type: PrivateOfferCreationActionTypes.ADD_ROWS_ON_PRIVATE_OFFER,
  payload: { key, productId, type },
})
export const deleteRowsOnPrivateOffer =
  (key: string, index: number, productId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const cloudType = getState().productListingFilters.cloudMarketplace
    await dispatch(deleteRows(key, index, productId))
    if (validateFields.includes(key)) {
      await dispatch(setErrorsOnPrivateOfferCreation(key, productId, cloudType))
    }
  }
export const deleteRows = (key: string, index: number, productId: string) => ({
  type: PrivateOfferCreationActionTypes.DELETE_ROWS_ON_PRIVATE_OFFER,
  payload: { key, index, productId },
})
// Re-export for backward compatibility
export type { KeyValue } from './types'
export const updatevaluesInArrayOfPrivateOffers =
  (key: string, index: number, privateOfferData: KeyValue, productId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState()
    const cloudType = state.productListingFilters.cloudMarketplace
    const standardDimension = state.productsListing[
      cloudType
    ].products.rows.filter(val => val.productId === productId)[0]
      .productDimensions

    await dispatch(
      setValuesInArrayOfPrivateOffers(
        key,
        index,
        privateOfferData,
        productId
      ) as unknown as AnyAction
    )
    if (validateFields.includes(key)) {
      const timeZone = getState().userProfile.userProfile.timeZone || 'UTC'
      await dispatch(
        setErrorsOnPrivateOfferCreation(
          key,
          productId,
          cloudType,
          standardDimension,
          privateOfferData.key,
          index,
          timeZone
        ) as unknown as AnyAction
      )
    }
  }

export const setValuesInArrayOfPrivateOffers = (
  key: string,
  index: number,
  privateOfferData: KeyValue,
  productId: string
) => ({
  type: PrivateOfferCreationActionTypes.UPDATE_VALUES_OF_ARRAY_ON_PRIVATE_OFFER,
  payload: { key, privateOfferData, index, productId },
})
export const updateNoOfTimesSaved = (productId: string) => ({
  type: PrivateOfferCreationActionTypes.UPDATE_NUMBER_OF_TIMES_SAVED_ON_PRIVATE_OFFER,
  payload: productId,
})
export const setFieldMetaData = (
  productId: string,
  fieldMetadata: FieldMetadata
) => ({
  type: PrivateOfferCreationActionTypes.SET_FIELD_METADATA,
  payload: { productId, fieldMetadata },
})

export const setErrorsOnPrivateOfferCreation = (
  key: string,
  productId: string,
  cloudType: CloudMarketplace,
  standardDimensions?: ProductDimension[],
  field?: string,
  index?: number,
  timeZone?: string
) => ({
  type: PrivateOfferCreationActionTypes.UPDATE_PRIVATE_OFFER_CREATION_ERRORS,
  payload: {
    key,
    productId,
    cloudType,
    field,
    index,
    timeZone,
    standardDimensions,
  },
})

export const setSingleFieldErrorOnPrivateOfferCreation = (
  key: string,
  productId: string,
  errMsg: string
) => ({
  type: PrivateOfferCreationActionTypes.UPDATE_PRIVATE_OFFER_SINGLE_FIELD_ERROR,
  payload: {
    key,
    productId,
    errMsg,
  },
})

export const addEulaFilesOnPrivateOffer = (
  productId: string,
  eulaFiles: string[]
) => ({
  type: PrivateOfferCreationActionTypes.ADD_EULA_FILES_ON_PRIVATE_OFFERS,
  payload: { productId, eulaFiles },
})
export const getFilteredDimensions = (dimensions: Dimension[]) => {
  return dimensions.filter(dimension => {
    if (!isEmpty(dimension.isAdditionalUsageAllowed)) {
      if (!isEmpty(dimension.dimensionId)) {
        return dimension
      }
    } else {
      if (!isEmpty(dimension.name) && !isEmpty(dimension.labelDescription)) {
        return dimension
      }
    }
  })
}
export const getFilteredInstallments = (installments: Installments[]) => {
  return installments.filter(installment => {
    if (
      installment.amount !== null &&
      isNonEmptyNumber(installment.amount) &&
      !isEmpty(installment.paymentDate)
    ) {
      return installment
    }
  })
}
export const getZeroDollarPricing = (dimensions: Dimension[]) => {
  return dimensions.some(dimension => {
    if (dimension?.price && Number(dimension?.price) !== 0) {
      return false
    }
    return true
  })
}

export const returnOnlySpecificDimensionsField = (
  dimensions: Dimension[],
  selectedCurrency?: string
) => {
  return dimensions.map(
    ({
      currency,
      type,
      awsProductId,
      createdAt,
      crmObjectId,
      dimensionId,
      isAdditionalUsageAllowed,
      labelDescription,
      label,
      name,
      price,
      quantity,
    }) => ({
      currency: selectedCurrency,
      type,
      awsProductId,
      createdAt,
      crmObjectId,
      dimensionId,
      isAdditionalUsageAllowed,
      labelDescription,
      label,
      name,
      price,
      quantity,
    })
  )
}

const getPlansforPayload = (
  plans?: AzureOfferPlan[],
  azurePricingType?: AzurePricingType,
  selectedProduct?: Product
) => {
  if (plans && azurePricingType && selectedProduct) {
    const updatedPlans = cloneDeep(plans).map(
      ({
        displayName,
        labraPlanId,
        offerPricingType,
        discountPercentage,
        pricing,
        originalPricing,
        description,
      }) => {
        const pricingData = {
          ...getAzurePricingObject({
            pricing,
            originalPricing,
            azurePricingType,
            discountPercentage,
          }),
        }

        const disountData =
          azurePricingType === AzurePricingType.LABRA_PERCENTAGE
            ? { discountPercentage }
            : {}

        return {
          displayName,
          labraPlanId,
          description,
          cloudProductId: selectedProduct.cloudMarketplaceProductId,
          cloudProductName: selectedProduct.productName,
          offerPricingType,
          discountType: azurePricingType,
          ...(azurePricingType === AzurePricingType.ABSOLUTE
            ? { customPlanName: displayName }
            : {}),
          ...pricingData,
          ...disountData,
        }
      }
    )
    return [...updatedPlans]
  } else {
    return []
  }
}

const getAzurePricingObject = ({
  pricing,
  originalPricing,
  azurePricingType,
  discountPercentage,
}: {
  pricing: AzurePOPricing
  originalPricing?: AzurePOPricing
  azurePricingType?: AzurePricingType
  discountPercentage?: number
}) => {
  const { userLimits, prices, ...remainingRecurrentPrice } =
    pricing.recurrentPrice

  const isDiscounted = azurePricingType === AzurePricingType.LABRA_PERCENTAGE
  const updatedUserLimits = userLimits
    ? {
        min: userLimits.minEnable
          ? userLimits.min
          : originalPricing?.recurrentPrice.userLimits.min,
        max: userLimits.maxEnable
          ? userLimits.max
          : originalPricing?.recurrentPrice.userLimits.max,
      }
    : null
  const recurrentPricingPayload = {
    ...remainingRecurrentPrice,
    prices: prices.map((priceObject, idx) => ({
      ...priceObject,
      pricePerPaymentInUsd:
        isDiscounted && originalPricing?.recurrentPrice?.prices[idx]
          ? getDiscountedPriceValue({
              price:
                originalPricing.recurrentPrice.prices[idx]
                  .pricePerPaymentInUsd!,
              discount: discountPercentage,
            })
          : priceObject?.pricePerPaymentInUsd,
    })),
    userLimits:
      updatedUserLimits &&
      isNonEmptyNumber(updatedUserLimits.min) &&
      isNonEmptyNumber(updatedUserLimits.max)
        ? { ...updatedUserLimits }
        : null,
  }

  let mmetersPayload = {}
  pricing?.customMeters?.meters &&
    Object.keys(pricing?.customMeters?.meters).forEach(meterKey => {
      const currentMeter = { ...pricing?.customMeters?.meters[meterKey] }
      mmetersPayload = {
        ...mmetersPayload,
        [meterKey]: {
          ...currentMeter,
          pricePerPaymentInUsd:
            isDiscounted && originalPricing?.customMeters?.meters[meterKey]
              ? getDiscountedPriceValue({
                  price:
                    originalPricing.customMeters.meters[meterKey]
                      .pricePerPaymentInUsd!,
                  discount: discountPercentage,
                })
              : currentMeter?.pricePerPaymentInUsd,
          includedQuantities: pricing?.customMeters?.meters[
            meterKey
          ].includedQuantities.map(includedQuantityItem => ({
            billingTerm: includedQuantityItem.billingTerm,
            isInfinite: includedQuantityItem.isInfinite,
            ...(!includedQuantityItem.isInfinite
              ? { quantity: includedQuantityItem.quantity }
              : {}),
          })),
        },
      }
    })

  return {
    pricing: {
      recurrentPrice: { ...recurrentPricingPayload },
      customMeters: {
        priceInputOption: AzurePriceInputOption.USD,
        meters: {
          ...mmetersPayload,
        },
      },
    },
  }
}

export const getGCPPlanDataBasedOnType = (
  plan: GCPOfferPlan,
  individualDiscount?: boolean
) => {
  const commonPlanPayload = {
    id: plan?.planId,
    currency: 'USD',
  }
  if (plan?.planType === PlanTypeGCP.FLAT_FEE) {
    if (plan?.paymentType === PaymentType.CUSTOM) {
      return {
        ...commonPlanPayload,
        installmentInfo:
          plan?.serviceLength && plan?.installmentSchedule
            ? (plan?.installmentInfo || [])?.map(
                ({ flatFeePrice, installmentDate }) => ({
                  flatFeePrice,
                  installmentDate: DateTime.fromISO(
                    installmentDate as string
                  ).toISO(),
                })
              )
            : [],
      }
    } else {
      return {
        ...commonPlanPayload,
        flatFeePrice: plan?.flatFeePrice,
      }
    }
  } else if (plan?.planType === PlanTypeGCP.FLAT_FEE_USAGE) {
    if (plan?.paymentType === PaymentType.CUSTOM) {
      return {
        ...commonPlanPayload,
        installmentInfo:
          plan?.serviceLength && plan?.installmentSchedule
            ? (plan?.installmentInfo || [])?.map(
                ({ flatFeePrice, installmentDate, metricPricing }) => ({
                  flatFeePrice,
                  installmentDate: DateTime.fromISO(
                    installmentDate as string
                  ).toISO(),
                  metricPricing:
                    individualDiscount ||
                    (!individualDiscount && isNonEmptyNumber(plan?.discount))
                      ? (metricPricing || [])?.map(
                          ({ discount, id, price }) => ({
                            price,
                            cloudDimensionId: id,
                            discount: individualDiscount
                              ? discount
                              : plan?.discount,
                          })
                        )
                      : [],
                })
              )
            : [],
      }
    } else {
      return {
        ...commonPlanPayload,
        flatFeePrice: plan?.flatFeePrice,
        metricPricing:
          individualDiscount ||
          (!individualDiscount && isNonEmptyNumber(plan?.discount))
            ? (plan?.metricPricing || [])?.map(({ discount, id, price }) => ({
                price,
                cloudDimensionId: id,
                discount: individualDiscount ? discount : plan?.discount,
              }))
            : [],
      }
    }
  } else {
    return {
      ...commonPlanPayload,
      metricPricing:
        individualDiscount ||
        (!individualDiscount && isNonEmptyNumber(plan?.discount))
          ? (plan?.metricPricing || [])?.map(({ discount, id, price }) => ({
              price,
              cloudDimensionId: id,
              discount: individualDiscount ? discount : plan?.discount,
            }))
          : [],
    }
  }
}

const getOfferRecipients = (offerRecipients: OfferRecipients[]) => {
  return offerRecipients.filter(
    offerRecipientItem =>
      !isEmpty(offerRecipientItem.firstName) ||
      !isEmpty(offerRecipientItem.lastName) ||
      !isEmpty(offerRecipientItem.email) ||
      !isEmpty(offerRecipientItem.title)
  )
}

const getOfferMetaData = (metaData: MetaData[]) => {
  return metaData.filter(
    metaDataItem => !isEmpty(metaDataItem.key) || !isEmpty(metaDataItem.value)
  )
}

const getFilteredPlans = (plans: AzureOfferPlan[]) => {
  return plans.filter(planItem => !isEmpty(planItem.labraPlanId))
}

type PrivateOfferSpecificData = {
  containerOfferServiceLength: string
  usageDuration: string
  customOfferStakeholders: OfferStakeholders[]
  dimensions: Dimension[]
}

const getContainerOfferTransformForFormik = (
  privateOffer: OffersWithErrors,
  privateOfferSpecificData: PrivateOfferSpecificData,
  selectedProduct: Product
) => {
  const {
    containerOfferServiceLength,
    usageDuration,
    customOfferStakeholders,
    dimensions,
  } = privateOfferSpecificData

  const containerOfferServiceLengthValue = (containerOfferServiceLength ||
    '') as string
  const contractDurationVal =
    selectedProduct.containerPricingModel === ContainerPricingModel.CONTRACT
      ? containerOfferServiceLengthValue +
        (containerOfferServiceLengthValue.endsWith('M') ? '' : 'M')
      : containerOfferServiceLengthValue +
        (containerOfferServiceLengthValue.endsWith('Y') ||
        containerOfferServiceLengthValue.endsWith('H')
          ? ''
          : 'D')

  return {
    usageDuration:
      !isNil(usageDuration) && usageDuration !== '' ? usageDuration : null,
    offerRecipients: getOfferRecipients(privateOffer?.offerRecipients || []),
    metaData: getOfferMetaData(privateOffer?.metaData || []),
    offerStakeholders: privateOffer?.offerStakeholders?.concat(
      (customOfferStakeholders || []) as OfferStakeholders[]
    ),
    containerOfferServiceLength: contractDurationVal,
    dimensions: isOneHourContractDuration(
      privateOffer?.containerOfferServiceLength || ''
    )
      ? ((dimensions || []) as Dimension[]).filter(
          dimensionItem => dimensionItem.isAdditionalUsageAllowed
        )
      : dimensions,
  }
}

export const getPayloadDataBasedOnCloud = ({
  cloud,
  privateOfferData,
  getState,
  saveAsDraft,
  crmOpportunityId,
  creatorData,
  selectedProduct,
}: {
  cloud: CloudMarketplace
  privateOfferData: OffersWithErrors
  getState: () => RootState
  saveAsDraft?: boolean
  crmOpportunityId?: string
  creatorData?: {
    creatorName: string
    creatorEmail: string
  }
  selectedProduct?: Product
}) => {
  const { errors, hasBeenSent, noOfTimesSaved, ...privateOffer } =
    privateOfferData
  const {
    givenName: firstName,
    familyName: lastName,
    email,
  } = getState().userProfile.userProfile
  switch (cloud) {
    case 'AWS': {
      let privateOfferToBeSent = {} as Record<string, unknown>
      const shouldUseFormStakeholders =
        selectedProduct?.productType === PlanType.SAAS_CONTRACT ||
        selectedProduct?.productType === PlanType.SAAS_SUBSCRIPTION ||
        selectedProduct?.productType === PlanType.AMI
      const offerStakeholders = shouldUseFormStakeholders
        ? [
            ...((privateOffer?.offerStakeholders as OfferStakeholders[]) || []),
            ...(Array.isArray(privateOffer?.customOfferStakeholders)
              ? privateOffer.customOfferStakeholders
              : []),
          ]
        : [
            {
              firstName: firstName || '',
              lastName: lastName || '',
              email: email || '',
            },
          ]
      if (privateOffer.flexiblePaymentTerms) {
        const dimensions = (privateOffer?.dimensions || []).map(dimension => {
          if (dimension.isAdditionalUsageAllowed) {
            const { type, ...remainingDimension } = dimension
            return remainingDimension
          }
          const { type, price, ...updatedDimension } = dimension
          return updatedDimension
        })
        const { installments, flexiblePaymentType, ...updatedOffer } =
          privateOffer
        privateOfferToBeSent = {
          ...updatedOffer,
          dimensions,
          installmentInfo: [...installments!],
          flexiblePaymentType,
        }
      } else {
        const dimensions = (privateOffer?.dimensions || []).map(dimension => {
          if (dimension.isAdditionalUsageAllowed) {
            const { type, prices, ...remainingDimension } = dimension
            return remainingDimension
          }
          const { type, prices, quantity, ...updatedDimension } = dimension
          return updatedDimension
        })
        const { installments, ...updatedOffer } = privateOffer
        privateOfferToBeSent = {
          ...updatedOffer,
          dimensions,
          installmentInfo: installments,
        }
      }
      const zeroDollarPricing = getZeroDollarPricing(
        privateOffer?.dimensions || []
      )
      privateOfferToBeSent.zeroDollarPricing = zeroDollarPricing
      if (isEmpty(privateOffer.subscriptionEndDate)) {
        const { subscriptionEndDate, ...remainingOffer } = privateOfferToBeSent
        privateOfferToBeSent = { ...remainingOffer }
      }
      privateOfferToBeSent.dimensions = returnOnlySpecificDimensionsField(
        getFilteredDimensions(
          privateOfferToBeSent.dimensions as unknown as Dimension[]
        ),
        privateOfferToBeSent?.currency as string
      )
      const installments = getFilteredInstallments(
        (privateOfferToBeSent.installmentInfo ||
          []) as unknown as Installments[]
      )
      privateOfferToBeSent.installmentInfo = installments.map(inst => ({
        ...inst,
        currency: privateOfferToBeSent.currency,
      }))

      if (
        selectedProduct?.productType === PlanType.AMI &&
        privateOfferData?.pricingModel !== 'installment-plan'
      ) {
        privateOfferToBeSent.installmentInfo = null
        privateOfferToBeSent.flexiblePaymentTerms = false
        privateOfferToBeSent.flexiblePaymentType = null
        privateOfferToBeSent.firstInstallmentDate = null
      }

      privateOfferToBeSent.offerExpirationDate = isEmpty(
        privateOfferData.offerExpirationDate
      )
        ? null
        : privateOfferData.offerExpirationDate
      privateOfferToBeSent.offerStakeholders = [...offerStakeholders]

      // Calculate usageDuration as difference in days between offerExpirationDate and usageEndDate
      if (
        selectedProduct?.productType === PlanType.AMI &&
        privateOfferToBeSent.usageEndDate &&
        !isEmpty(privateOfferToBeSent.usageEndDate)
      ) {
        const calculatedUsageDuration = calculateUsageDurationFromDates({
          offerExpirationDate:
            privateOfferToBeSent?.offerExpirationDate as string,
          usageEndDate: privateOfferToBeSent.usageEndDate as string,
        })
        if (calculatedUsageDuration !== null) {
          privateOfferToBeSent.usageDuration = calculatedUsageDuration
        }
      }
      const {
        usageDuration,
        variableStartDate,
        agreementStartDate,
        customOfferStakeholders,
        dimensions,
        containerOfferServiceLength,
        metaData: metaDataValue,
        tcv,
        flexiblePaymentType,
        firstInstallmentDate,
        offerStartDate,
        usageEndDate,
        pricingModel,
        durationType,
        durationLength,
        pricingToolType,
        ...remainingOfferToBesent
      } = privateOfferToBeSent
      return {
        ...remainingOfferToBesent,
        // metaData: metaDataValue?.map((item) => ({ key: item?.key, value: item?.value })),
        ...(selectedProduct?.productType === PlanType.SAAS_CONTRACT
          ? {
              variableStartDate,
              ...(!variableStartDate && !isEmpty(agreementStartDate)
                ? { agreementStartDate }
                : { agreementStartDate: null }),
            }
          : {}),
        ...(selectedProduct?.productType === PlanType.CONTAINER
          ? {
              ...getContainerOfferTransformForFormik(
                privateOfferData,
                {
                  usageDuration: usageDuration as string,
                  customOfferStakeholders:
                    customOfferStakeholders as OfferStakeholders[],
                  dimensions: dimensions as Dimension[],
                  containerOfferServiceLength:
                    containerOfferServiceLength as string,
                },
                selectedProduct
              ),
            }
          : selectedProduct?.productType === PlanType.AMI
            ? {
                dimensions: privateOfferData?.dimensions?.map(
                  ({ id, quantity, price, ...dimension }) => ({
                    ...dimension,
                    quantity: quantity || null,
                    price: price || null,
                  })
                ),
                usageDuration: (() => {
                  const computedUsageDuration = getUsageDuration(
                    usageDuration,
                    privateOfferData?.offerExpirationDate,
                    privateOfferData?.usageEndDate
                  )

                  if (privateOfferData?.pricingModel === 'installment-plan') {
                    return null
                  }

                  return computedUsageDuration
                })(),
                containerOfferServiceLength:
                  containerOfferServiceLength || null,
                ...(tcv !== null && tcv !== undefined ? { tcv } : {}),
                ...(firstInstallmentDate ? { firstInstallmentDate } : {}),
                ...(flexiblePaymentType ? { flexiblePaymentType } : {}),
              }
            : { dimensions }),
        metaData: ((metaDataValue as MetaData[]) || [])
          ?.filter(item => item?.key || item?.value)
          ?.map((item: MetaData) => ({ key: item?.key, value: item?.value })),
      }
    }
    case 'AZURE': {
      let privateOfferToBeSent = {} as Record<string, unknown>
      const {
        plans,
        crmOrderObjectId,
        variableStartDate,
        existingContractRenewal,
        eulaFiles,
        billingAccountId,
        companyName,
        metaData,
        offerRecipients,
        privateOfferName,
        emailCustomMessage,
        azurePricingType,
        privateOfferId,
        preparedBy,
        customOfferStakeholders,
        offerStakeholders,
        offerDescription,
      } = privateOffer
      const cloudProductId = selectedProduct?.cloudMarketplaceProductId

      const offerStartDate = isEmpty(privateOffer.offerStartDate)
        ? null
        : DateTime.fromISO(privateOffer.offerStartDate!).toISO()

      const acceptBy = isEmpty(privateOffer.acceptBy)
        ? null
        : DateTime.fromISO(privateOffer.acceptBy!).toISO()

      const offerExpirationDate = isEmpty(privateOfferData.offerExpirationDate)
        ? null
        : DateTime.fromISO(privateOffer.offerExpirationDate!).toISO()

      const processMeters = (
        meters: Record<string, any>
      ): Record<string, any> => {
        const snakeizedMeters: Record<string, any> = {}

        Object.keys(meters).forEach(meterKey => {
          snakeizedMeters[meterKey] = snakeize(meters[meterKey])
        })

        return snakeizedMeters
      }

      const payloadPlans = plans
        ?.filter(item => item?.labraPlanId)
        .map(({ originalPricing, pricing, ...remainingPlan }) => {
          const isItPerUser =
            pricing?.recurrentPrice?.recurrentPriceMode ===
            RecurrentPriceModeType.PERUSER

          const { userLimits, ...remainingRecurrentPrice } =
            pricing?.recurrentPrice

          const hasInstallmentSchedules =
            (pricing?.recurrentPrice?.prices?.[0]?.installments?.schedule
              ?.length ?? 0) > 0

          return {
            ...snakeize(remainingPlan),
            discount_type: azurePricingType,
            pricing: {
              recurrent_price: snakeize({
                ...remainingRecurrentPrice,
                ...(isItPerUser ? { userLimits } : {}),
                price_input_option: 'usd',
                ...(hasInstallmentSchedules
                  ? {
                      prices: [
                        {
                          ...remainingRecurrentPrice?.prices?.[0],
                          paymentOption: {
                            ...remainingRecurrentPrice?.prices?.[0]
                              ?.paymentOption,
                            type: 'flexible',
                          },
                          pricePerPaymentInUsd: undefined,
                        },
                      ],
                    }
                  : {}),
              }),
              custom_meters: {
                ...pricing?.customMeters,
                meters: processMeters(pricing?.customMeters?.meters || {}),
                price_input_option: 'usd',
              },
            },
          }
        })
      privateOfferToBeSent = {
        crmOrderObjectId,
        privateOfferId,
        privateOfferName,
        privateOfferType: 'customerPromotion',
        offerPricingType: 'saasNewCustomizedPlans',
        offerDescription,
        offerStartDate,
        offerExpirationDate,
        acceptBy,
        ...(preparedBy || creatorData?.creatorEmail
          ? { preparedBy: preparedBy || creatorData?.creatorEmail }
          : {}),
        eulaType: privateOffer.eulaType,
        eulaFiles,
        billingAccountId,
        cloudProductId,
        pricing: [],
        offerRecipients: getOfferRecipients(offerRecipients || []),
        companyName,
        emailCustomMessage,
        metaData: getOfferMetaData(metaData || []),
        plans: payloadPlans,
        labraProductId: selectedProduct?.productId,
        productName: selectedProduct?.productName,
        offerStakeholders: crmOpportunityId
          ? []
          : offerStakeholders?.concat(
              (customOfferStakeholders || [])?.map(({ email }) => ({
                email: email,
                firstName: '',
                lastName: '',
                title: '',
              }))
            ),
        ...(variableStartDate !== undefined ? { variableStartDate } : {}),
        existingContractRenewal: existingContractRenewal || false,
        ...(saveAsDraft
          ? { offerStatus: OfferStatus.PRIVATE_OFFER_IN_DRAFT }
          : { offerStatus: OfferStatus.PRIVATE_OFFER_CREATION_IN_PROGRESS }),
      }
      return privateOfferToBeSent
    }
    case 'GCP': {
      const {
        companyName,
        buyerCloudBillingId,
        eulaFile,
        autoRenew,
        emailCustomMessage,
        offerStakeholders,
        notes,
        eulaType,
        plan,
        renewalCount,
        privateOfferName,
        offerExpirationDate,
        offerRecipients,
        serviceStartDate,
        privateOfferId,
        labraPlanFeatures,
        dealType,
      } = privateOffer

      const tcvValue =
        plan?.planType !== PlanTypeGCP.USAGE
          ? {
              ...(plan?.paymentType &&
              GcpPostPaymentTypes.includes(plan?.paymentType) &&
              !isNil(plan?.serviceLength) &&
              !isNil(plan?.flatFeePrice)
                ? {
                    tcv: Number(
                      plan?.serviceLength * plan?.flatFeePrice
                    ).toFixed(2),
                  }
                : {}),
              ...(plan?.paymentType === PaymentType.CUSTOM
                ? { tcv: plan?.tcv }
                : {}),
            }
          : {}

      return {
        draft: saveAsDraft,
        crmOpportunityId,
        serviceStartDate,
        offerStatus: OfferStatus.PRIVATE_OFFER_CREATION_IN_PROGRESS,
        buyerCloudBillingId,
        privateOfferName,
        eulaType,
        paymentFrequency:
          plan?.planId && plan?.paymentType ? plan?.paymentType : undefined,
        companyName,
        eulaFiles: eulaFile,
        autoRenew,
        offerExpirationDate: DateTime.fromISO(
          offerExpirationDate as string
        ).toISO(),
        offerRecipients,
        offerStakeholders,
        offerMetadata: {
          notes,
          emailCustomMessage,
        },
        contractDuration: plan?.serviceLength,
        labraProductId: selectedProduct?.productId,
        cloud: 'GCP',
        labraPlanId: plan?.planId ? plan?.planId : undefined,
        labraPlanFeatures,
        ...tcvValue,
        ...(plan?.installmentSchedule
          ? { installmentSchedule: upperCase(plan?.installmentSchedule) }
          : {}),
        individualDiscount: plan?.individualDiscount,
        plan:
          plan && plan?.planId
            ? getGCPPlanDataBasedOnType(plan, plan?.individualDiscount)
            : {},
        flexiblePaymentTerms: plan?.paymentType === PaymentType.CUSTOM,
        ...(privateOfferId
          ? { labraOfferId: privateOfferId, privateOfferId }
          : {}),
        ...(autoRenew ? { renewalCount: renewalCount } : {}),
        ...(dealType ? { dealType: dealType } : {}),
      }
    }
    case 'REDHAT': {
      return {}
    }
  }
}

export const postOfferBasedOnCloud = async (
  cloud: CloudMarketplace,
  OfferPayload: {
    partnerId: string
    data: Record<string, unknown>
    saveAsDraft?: boolean
  }
) => {
  switch (cloud) {
    case 'AWS': {
      return await postPrivateOffer(OfferPayload)
    }
    case 'AZURE': {
      return await postAzurePrivateOffer(OfferPayload)
    }
    case 'GCP': {
      return await putGCPPrivateOffersData(OfferPayload)
    }
  }
}

export const patchOfferBasedOnCloud = async (
  cloud: CloudMarketplace,
  OfferPayload: {
    partnerId: string
    data: Record<string, unknown>
    saveAsDraft?: boolean
    privateOfferId: string
  }
) => {
  const { partnerId, data, saveAsDraft, privateOfferId } = OfferPayload
  switch (cloud) {
    case 'AWS': {
      return await patchPrivateOffersData(
        partnerId,
        privateOfferId as string,
        data,
        saveAsDraft
      )
    }
    case 'AZURE': {
      return await patchAzurePrivateOffersData(
        partnerId,
        privateOfferId as string,
        data,
        saveAsDraft
      )
    }
    case 'GCP': {
      return await putGCPPrivateOffersData({
        data,
        partnerId,
      })
    }
  }
}

export const sendPrivateOffer =
  ({
    partnerId,
    productId,
    saveAsDraft,
    crmOpportunityId,
    crmObjectLink,
    formikOffer,
    isV2,
    autoSave,
    creatorData,
  }: {
    partnerId: string
    productId: string
    saveAsDraft?: boolean
    crmOpportunityId?: string
    crmObjectLink?: string
    formikOffer?: OffersWithErrors
    isV2?: boolean
    autoSave?: boolean
    creatorData?: {
      creatorName: string
      creatorEmail: string
    }
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    if (!isV2 || saveAsDraft) {
      await dispatch(startLoading(LoadingTypes.GENERAL))
    } else {
      await dispatch(startLoading(LoadingTypes.SUBMIT_FLYOUT_Offer))
    }
    try {
      const selectedCloud = getState().productListingFilters.cloudMarketplace
      const privateOfferData =
        selectedCloud === 'GCP' || isV2
          ? formikOffer!
          : getState().privateOffersInCreation.currentPrivateOfferInCreation[
              productId
            ]
      const selectedProduct = getState().productsListing[
        selectedCloud
      ].products?.rows.find(product => product.productId === productId)

      const privateOfferToBeSent = getPayloadDataBasedOnCloud({
        cloud: selectedCloud,
        privateOfferData,
        getState,
        saveAsDraft,
        crmOpportunityId,
        creatorData,
        selectedProduct,
      })

      let crmMetadata = {} as Record<string, unknown>
      if (crmOpportunityId && crmObjectLink) {
        crmMetadata = {
          crmType: defaultCrmType,
          crmObjectLink,
        }
      }

      const { privateOfferId, plans, ...privateOfferToBeSentWithoutId } =
        privateOfferToBeSent
      if (saveAsDraft) {
        privateOfferToBeSent.draft = true
      }

      if (isEmpty(privateOfferId)) {
        const payload = {
          partnerId,
          data: snakeize({
            ...privateOfferToBeSentWithoutId,
            ...(crmOpportunityId ? { crmMetadata } : {}),
            ...(creatorData ? { creatorData } : {}),
            ...(selectedCloud === 'AZURE' ? { plans } : {}),
          }),
          saveAsDraft,
        }
        const response = await postOfferBasedOnCloud(selectedCloud, payload)
        if (response && response.data) {
          if ((selectedCloud === 'GCP' || isV2) && formikOffer) {
            await updateFormikOfferAfterAPICall(
              formikOffer,
              dispatch,
              productId,
              0,
              camelize(response.data).privateOfferId ||
                (camelize(response.data).id as string)
            )
          } else {
            await dispatch(
              updatePrivateOfferInCreation(
                {
                  key: 'privateOfferId',
                  value:
                    camelize(response.data).privateOfferId ||
                    camelize(response.data).id,
                },
                productId
              ) as unknown as AnyAction
            )
          }
        }
      } else {
        const patchPayload = {
          partnerId,
          data: {
            ...snakeize({
              ...privateOfferToBeSentWithoutId,
              ...(selectedCloud !== 'AZURE' ? { draft: saveAsDraft } : {}),
              ...(crmOpportunityId ? { crmMetadata } : {}),
              ...(selectedCloud === 'GCP'
                ? { labraOfferId: privateOfferId }
                : {}),
              ...(creatorData ? { creatorData } : {}),
              ...(selectedCloud === 'AZURE' ? { plans } : {}),
            }),
          },
          privateOfferId: privateOfferId as string,
          saveAsDraft,
        }
        const { subscription, ...restData } = patchPayload.data
        patchPayload.data = restData
        await patchOfferBasedOnCloud(selectedCloud, patchPayload)
        if ((selectedCloud === 'GCP' || isV2) && formikOffer) {
          await updateFormikOfferAfterAPICall(
            formikOffer,
            dispatch,
            productId,
            2,
            privateOfferId as string
          )
        }
      }
      if (!saveAsDraft) {
        await dispatch(updateHasBeenSent(true, productId))
      } else {
        await dispatch(updateNoOfTimesSaved(productId))
      }
      dispatch(
        updateAppAlert({
          message: saveAsDraft
            ? privateOfferSaveSuccess
            : privateOfferCreationSuccess,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )

      emitSalesforceResourceSaved({
        resourceType: 'offer',
        partnerId,
        opportunityId: crmOpportunityId || null,
        offer: {
          id:
            privateOfferToBeSent.privateOfferId || formikOffer?.privateOfferId,
          draft: !!saveAsDraft,
          hasBeenSent: !saveAsDraft,
          productId,
        },
      })
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      if (!isV2 || saveAsDraft) {
        await dispatch(stopLoading(LoadingTypes.GENERAL))
      } else {
        await dispatch(stopLoading(LoadingTypes.SUBMIT_FLYOUT_Offer))
      }
    }
  }

const updateFormikOfferAfterAPICall = async (
  formikOffer: OffersWithErrors,
  dispatch: AppDispatch,
  productId: string,
  noOfTimesSaved: number,
  privateOfferId?: string
) => {
  const { errors, ...remainingOffer } = formikOffer as OffersWithErrors
  await dispatch(
    setPrivateOfferInCreation({
      productId,
      data: { ...remainingOffer, privateOfferId: privateOfferId },
      errors: {},
      noOfTimesSaved,
    })
  )
}

export const updateHasBeenSent = (hasBeenSent: boolean, productId: string) => ({
  type: PrivateOfferCreationActionTypes.UPDTE_PRIVATE_OFFER_HAS_BEEN_SENT,
  payload: { hasBeenSent, productId },
})

// Re-export for backward compatibility
export { initialPricesObject } from './types'
export const createOfferErrors = (
  data: Record<string, unknown>,
  arrayFieldsForOfferValidations: string[],
  isResale = false
) => {
  const errors = Object.keys(data).map(key => {
    if (arrayFieldsForOfferValidations.includes(key)) {
      const temp: Array<Record<string, unknown>> = [] as Array<
        Record<string, unknown>
      >
      if (data[key] !== null) {
        // eslint-disable-next-line @typescript-eslint/no-extra-semi
        ;(data[key] as Array<Record<string, unknown>>).forEach(field => {
          if (isResale && key === 'dimensions') {
            temp.push({ ...initialPricesObject })
          } else if (key === 'plans') {
            temp.push({
              ...createErrorObjectForPlan(field as unknown as AzureOfferPlan),
            })
          } else {
            temp.push({
              ...getErrorObjectForAField(
                key,
                key === 'dimension'
                  ? (field as unknown as Dimension).type === 'custom'
                    ? 'custom'
                    : 'standard'
                  : ''
              ),
            })
          }
        })
        return temp
      } else {
        return []
      }
    } else return ''
  })
  const errorObject: Record<string, unknown> = {}
  Object.keys(data).forEach((key, index) => {
    errorObject[key] = errors[index]
  })
  return errorObject
}

export const clearPrivateOfferInCreation = (productId: string) => ({
  type: PrivateOfferCreationActionTypes.CLEAR_PRIVATE_OFFER_IN_CREATION,
  payload: productId,
})

export const updateProductPlanOnPrivateOffer = (
  index: number,
  productId: string,
  plan: AzureOfferPlan,
  keyForErrorCheck?: string,
  subIndex?: number,
  meter?: string,
  deleteBillingTerms?: boolean
) => ({
  type: PrivateOfferCreationActionTypes.UPDATE_PRODUCT_PLAN_ON_PRIVATE_OFFER,
  payload: {
    index,
    productId,
    plan,
    keyForErrorCheck,
    subIndex,
    meter,
    deleteBillingTerms,
  },
})

export const getDimensionFromProduct = (productPlan?: ProductPlan) => {
  if (productPlan) {
    return (productPlan?.dimensions as CommonDimensionField[])?.map(
      ({ currency, label, name, id, price }) => ({
        currency,
        label,
        name,
        id,
        price,
      })
    )
  }
  return []
}
export const getDefaultPrivateOfferInCreation =
  ({
    productId,
    crmOpportunityId,
    labraNewUiRevamp = false,
    crmId,
    crmObjectId,
    templateId,
    accountId,
    isHubspot,
  }: {
    productId: string
    crmOpportunityId?: string
    labraNewUiRevamp?: boolean
    crmId: string
    crmObjectId: string
    templateId?: string
    accountId?: string
    isHubspot?: boolean
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GET_DEFAULT_OFFERS))
    try {
      await dispatch(clearPrivateOfferInCreation(productId))
      const cloudMarketplace = getState().productListingFilters.cloudMarketplace
      const product =
        getState().productsListing[cloudMarketplace].products.rows.find(
          product => product.productId === productId
        ) || ({} as Product)
      const mappingTemplate = getState().marketplaceMappingManager.templateData

      const { data } = isHubspot
        ? await getMarketplaceDefaultOffersReferralMapping(
            crmId,
            crmObjectId,
            productId,
            templateId
          )
        : await getMarketplaceDefaultOfferMarketplaceMapping(
            crmId,
            templateId,
            accountId,
            crmObjectId
          )

      let extractedData = {}
      let fieldMetadata = {}

      if (isHubspot) {
        fieldMetadata = data?.field_metadata
        const [dynamicKey] = Object.keys(data).filter(
          key => key !== 'field_metadata'
        )
        extractedData = data[dynamicKey]
        if (extractedData && 'renewal' in extractedData) {
          extractedData.renewal =
            extractedData.renewal === 'true' ? true : false
        }
      } else {
        const referralObject = data?.referral_object
        const selectedTemplate = mappingTemplate?.templateData?.fieldMappings
        const dimensions = data?.dimensions
        extractedData = mappingReferralObjectToForm(
          productId,
          referralObject,
          dimensions,
          mappingTemplate,
          product
        )
        fieldMetadata = getFieldMetadataFromTemplate(
          selectedTemplate,
          referralObject
        )
      }

      let offerData = {}

      offerData = {
        ...getInitialPrivateOfferDataBasedOnCloud(
          cloudMarketplace,
          product,
          getState,
          crmOpportunityId,
          labraNewUiRevamp
        ),
        ...extractedData,
      }
      const finalData = camelize({
        ...offerData,
      })
      const errors =
        cloudMarketplace === 'GCP'
          ? {}
          : createOfferErrors(
              finalData,
              getArrayFieldsForValidation(cloudMarketplace)
            )
      await dispatch(
        setPrivateOfferInCreation({
          productId,
          data: { ...finalData },
          errors,
          noOfTimesSaved: 0,
        })
      )
      await dispatch(
        setFieldMetaData(productId, camelize({ ...fieldMetadata }))
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.GET_DEFAULT_OFFERS))
    }
  }

/** Maps core Salesforce referral fields + contract duration to private-offer form keys. */
export const getOfferDetailInfo = (
  referralObject: Record<string, unknown>
): Record<string, unknown> => {
  const out: Record<string, unknown> = {}
  const pickString = (sfField: string, formKey: string) => {
    const v = referralObject[sfField]
    if (v !== undefined && v !== null && String(v).trim() !== '') {
      out[formKey] = v
    }
  }

  pickString('Labra__Account_Id__c', 'aws_account_id')
  pickString('Labra__Company_Name__c', 'company_name')
  pickString('Labra__Offer_Name__c', 'private_offer_name')
  pickString('Labra__EULA_Type__c', 'eula_type')
  pickString('Labra__Entitlement_Option__c', 'entitlement_option')
  pickString('Labra__Subscription_End_Date__c', 'subscription_end_date')
  pickString('Labra__Subscription_Start_Date__c', 'agreement_start_date')
  pickString('Labra__Renewal_Type__c', 'renewalChannel')
  pickString('Labra__Offer_Expiration_Date__c', 'offer_expiration_date')
  pickString('Labra__Custom_Email_Message__c', 'emailCustomMessage')
  pickString('Labra__EULA_Attachment__c', 'eula_file')

  const contractMonthsRaw = referralObject.Labra__Contract_Duration_Months__c
  if (
    contractMonthsRaw !== undefined &&
    contractMonthsRaw !== null &&
    String(contractMonthsRaw).trim() !== ''
  ) {
    const n = Number(contractMonthsRaw)
    if (!Number.isNaN(n)) {
      out.service_length = n
    }
  }
  if (referralObject?.Labra__Subscription_Start_Date__c) {
    out.variableStartDate = false
  }
  const isFlexiblePaymentTerms =
    !!referralObject?.Labra__Installment_Amount__c ||
    !!referralObject?.Labra__Installment_Date__c
  if (isFlexiblePaymentTerms) {
    out.installments = [
      {
        amount: referralObject?.Labra__Installment_Amount__c,
        paymentDate: referralObject?.Labra__Installment_Date__c,
      },
    ]
  }

  const isRenewal = !!referralObject?.Labra__Renewal_Type__c
  if (isRenewal) {
    out.renewal = true
    out.renewalChannel = referralObject?.Labra__Renewal_Type__c
  }
  return {
    ...out,
    flexiblePaymentTerms: isFlexiblePaymentTerms,
  }
}

export const getMetadataFromReferralMapping = (
  referralObject: Record<string, unknown>,
  metadataMapping?: Record<string, MarketplaceFieldMappingMetadata>
): { key: string; value: string }[] | undefined => {
  if (!metadataMapping || Object.keys(metadataMapping).length === 0) {
    return undefined
  }
  const metaData = Object.values(metadataMapping)
    .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
    .map(meta => {
      const fromReferral = referralObject[meta.referralField]
      const hasReferral =
        fromReferral !== undefined &&
        fromReferral !== null &&
        String(fromReferral).trim() !== ''
      const value = hasReferral
        ? String(fromReferral)
        : Array.isArray(meta.defaultValue)
          ? meta.defaultValue.join(',')
          : String(meta.defaultValue ?? '')
      return { key: meta.key ?? '', value }
    })
    .filter(row => row.key !== '' || row.value !== '')
  return metaData.length > 0 ? metaData : undefined
}

export const getDimensionsFromReferralMapping = (
  productId: string,
  dimensions: Record<string, unknown>[] | null | undefined,
  fieldMappings: MarketplaceTemplatesDataFieldMappings | undefined,
  productDimensions: ProductDimension[] | undefined,
  product?: Product,
  isResale?: boolean
): ProductDimension[] | undefined => {
  if (!dimensions) {
    return undefined
  }
  const referredDimensionKeys = Object.keys(get(dimensions, productId, {}))
  const productIdList = Object.keys(
    fieldMappings?.dimensions?.dimensionsMapping || {}
  )
  if (!productIdList.includes(productId)) {
    return undefined
  }
  const selectedDimensions =
    fieldMappings?.dimensions?.dimensionsMapping[productId]
  if (!selectedDimensions) {
    return undefined
  }
  const dimensionsIdValues = Object.keys(selectedDimensions.dimensions)
    .map(key => ({ ...selectedDimensions.dimensions[key] }))
    .filter(dimensionItem =>
      referredDimensionKeys.includes(dimensionItem?.referralField as string)
    )
    .map(item => ({ id: item?.dimensionId, value: item?.defaultValue }))
  const dimensionsIds = dimensionsIdValues.map(item => item?.id)
  const selectedFromProduct = productDimensions?.filter(dimensionItem =>
    dimensionsIds.includes(dimensionItem?.id as string)
  )
  const updatedDimensions = selectedFromProduct?.map(
    ({ id, price, freeTrial, prices, valueDataType, ...selectedDimension }) => {
      const priceValue = dimensionsIdValues.find(item => item?.id === id)?.value
      return {
        ...selectedDimension,
        dimensionId: id,
        ...priceValueUpdateToDimensions({
          priceValue: priceValue as string,
          product,
          isResale,
        }),
        type: selectedDimension?.isAdditionalUsageAllowed
          ? ('additional_usage' as DimensionType)
          : ('standard' as DimensionType),
      }
    }
  )
  return updatedDimensions as ProductDimension[] | undefined
}

const priceValueUpdateToDimensions = ({
  priceValue,
  product,
  isResale,
}: {
  priceValue: string
  product?: Product
  isResale?: boolean
}) => {
  if (
    product &&
    product?.productType === PlanType.SAAS_SUBSCRIPTION &&
    isResale
  ) {
    return {
      prices: {
        price1m: null,
        price12m: null,
        price24m: null,
        price36m: null,
        subscriptionPrice: priceValue,
        additionalUsagePrice: null,
      },
    }
  }
  return {
    price: priceValue,
  }
}

const dimensionNameKey = (d: unknown): string | undefined => {
  if (!d || typeof d !== 'object') {
    return undefined
  }
  const n = (d as { name?: string }).name
  return typeof n === 'string' && n.trim() !== '' ? n.trim() : undefined
}

/** All mapped dimensions first, then product rows whose `name` is not in mapped (deduped by `name`). */
export const mergeMappedDimensionsWithProductDimensions = (
  mappedDimensions: ProductDimension[] | undefined | null,
  productDimensions: unknown[] | undefined | null
): unknown[] | undefined => {
  const base = Array.isArray(productDimensions) ? productDimensions : []
  const mapped = Array.isArray(mappedDimensions) ? mappedDimensions : []
  if (mapped.length === 0 && base.length === 0) {
    return undefined
  }
  const mappedNames = new Set(
    mapped.flatMap(d => {
      const key = dimensionNameKey(d)
      return key ? [key] : []
    })
  )
  const productOnly = base.filter(d => {
    const key = dimensionNameKey(d)
    return !key || !mappedNames.has(key)
  })
  return [...mapped, ...productOnly]
}

export const mappingReferralObjectToForm = (
  productId: string,
  referralObject: Record<string, unknown> | undefined | null,
  dimensions?: Record<string, unknown>[] | null,
  mappingTemplate?: MarketplaceTemplateData,
  product?: Product
): Record<string, unknown> => {
  if (!referralObject) {
    return {}
  }

  const fieldMappings = mappingTemplate?.templateData?.fieldMappings
  const out: Record<string, unknown> = {
    ...getOfferDetailInfo(referralObject),
  }

  const metaData = getMetadataFromReferralMapping(
    referralObject,
    fieldMappings?.metadata?.metadataMapping
  )
  if (metaData) {
    out.metaData = metaData
  }

  const mappedDimensions = getDimensionsFromReferralMapping(
    productId,
    dimensions,
    fieldMappings,
    product?.productDimensions,
    product,
    false
  )
  const dimensionsList = (
    product ? getDimensionsBasedOnProductType(product as Product, true) : []
  ) as ProductDimension[]

  const mergedDimensions = mergeMappedDimensionsWithProductDimensions(
    mappedDimensions,
    dimensionsList
  )
  if (mergedDimensions) {
    out.dimensions = mergedDimensions
  }

  return out
}

type FieldMappingFlags = { isHidden?: boolean; isReadonly?: boolean }

export const toFieldMetadataEntry = (
  field?: FieldMappingFlags | null
): { hidden: boolean; readOnly: boolean } => ({
  hidden: Boolean(field?.isHidden),
  readOnly: Boolean(field?.isReadonly),
})

/** Salesforce referral API name → private-offer form keys (snake_case; then camelized for Redux). */
export const referralFieldToFormMetadataKey: Record<string, string> = {
  Labra__Account_Id__c: 'aws_account_id',
  Labra__Company_Name__c: 'company_name',
  Labra__Offer_Name__c: 'private_offer_name',
  Labra__EULA_Type__c: 'eula_type',
  Labra__Entitlement_Option__c: 'entitlement_option',
  Labra__Subscription_End_Date__c: 'subscription_end_date',
  Labra__Subscription_Start_Date__c: 'agreement_start_date',
  Labra__Renewal_Type__c: 'renewal_channel',
  Labra__Offer_Expiration_Date__c: 'offer_expiration_date',
  Labra__Custom_Email_Message__c: 'email_custom_message',
  Labra__Contract_Duration_Months__c: 'service_length',
  Labra__Stakeholders__c: 'stakeholders',
  Labra__Metadata_Hide__c: 'metadata',
  Labra__EULA_Attachment__c: 'eula_file',
}

/** Resolves installment mapping rows to stable form keys (matches template labels / referral fields). */
export const installmentRowToFormKeySnake = (
  inst: MarketplaceFieldMappingInstallments,
  mappingObjectKey: string
): string => {
  const rf = inst.referralField?.trim() ?? ''
  if (rf) {
    const fromReferral = referralFieldToFormMetadataKey[rf]
    if (fromReferral) {
      return fromReferral
    }
  }
  const label = (inst.label ?? '').toLowerCase()
  if (label.includes('amount')) {
    return 'installment_amount'
  }
  if (label.includes('date')) {
    return 'installment_date'
  }
  return mappingObjectKey
}

const topLevelTemplateFieldMetadata: Array<{
  templateKey: keyof MarketplaceTemplatesDataFieldMappings
  formKey: string
}> = [
  { templateKey: 'awsAccountNumber', formKey: 'aws_account_id' },
  { templateKey: 'companyName', formKey: 'company_name' },
  { templateKey: 'recipient', formKey: 'offer_recipients' },
  { templateKey: 'customEmailMessage', formKey: 'email_custom_message' },
  { templateKey: 'contractDuration', formKey: 'service_length' },
  { templateKey: 'entitlementOption', formKey: 'entitlement_option' },
  { templateKey: 'renewal', formKey: 'renewal' },
  { templateKey: 'eula', formKey: 'eula_type' },
  { templateKey: 'customEula', formKey: 'eula_file' },
]

/**
 * Builds field visibility/editability metadata from the marketplace mapping template.
 * Keys are snake_case and then camelized when stored (e.g. aws_account_id → awsAccountId).
 */
export const getFieldMetadataFromTemplate = (
  template: MarketplaceTemplatesDataFieldMappings | undefined | null,
  _referralObject?: Record<string, unknown>
): Record<string, unknown> => {
  const out: Record<string, unknown> = {}

  const assign = (
    formKey: string | undefined,
    field?: FieldMappingFlags | null
  ) => {
    if (!formKey) {
      return
    }
    out[formKey] = toFieldMetadataEntry(field)
  }

  if (!template) {
    return camelize(out) as Record<string, unknown>
  }

  for (const { templateKey, formKey } of topLevelTemplateFieldMetadata) {
    const field = template[templateKey] as MarketplaceFieldMapping | undefined
    if (field && typeof field === 'object') {
      assign(formKey, field)
    }
  }

  const fieldsMapping = template.fields?.fieldsMapping
  if (fieldsMapping) {
    for (const mapping of Object.values(fieldsMapping)) {
      const referralField =
        typeof mapping?.referralField === 'string' ? mapping.referralField : ''
      const formKey = referralFieldToFormMetadataKey[referralField]
      if (formKey) {
        assign(formKey, mapping)
      }
    }
  }

  const metadataMapping = template.metadata?.metadataMapping
  if (metadataMapping) {
    const metadata = Object.values(metadataMapping).map(meta => {
      return {
        key: meta.key ?? '',
        value: meta.defaultValue ?? '',
        hidden: meta.isHidden,
        readOnly: meta.isReadonly,
      }
    })
    out.metadata = metadata
  }

  const installmentsMapping = template.installments?.installmentsMapping
  if (installmentsMapping) {
    for (const [installmentKey, inst] of Object.entries(installmentsMapping)) {
      assign(installmentRowToFormKeySnake(inst, installmentKey), inst)
    }
  }

  const recipientSourceMapping = (_referralObject?.Labra__Recipient_Source__c ||
    []) as Record<string, unknown>[]
  if (recipientSourceMapping.length > 0) {
    out.offerRecipientsList = {
      offerRecipients: recipientSourceMapping.map(recipient => ({
        firstName: recipient?.FirstName,
        lastName: recipient?.LastName,
        email: recipient?.email,
        title: recipient?.Title,
      })),
    }
  }

  return camelize(out) as Record<string, unknown>
}
